import React, { useState, useEffect } from "react";
import fetchData from "../actions/fetchData";
import IsFetchingAction from "../actions/isFetchingAction";
import Modal from "react-modal";
import CurrencyFormat from "react-currency-format";
import { ImCross } from "react-icons/im";

const PricePrediction = () => {
  const [data, setData] = useState({
    stats: [],
    coins: [],
  });
  const [IsFetching, setIsFetching] = useState(false);
  const [IsOpen, setIsOpen] = useState(false);
  const [PMCValue, setPMCValue] = useState(null);
  const [result, setResult] = useState({
    originalPrice: "",
    after: "",
  });

  const customStyles = {
    overlay: {
      background: "#39229e50",
      zIndex: "2",
    },
    content: {
      height: "25vh",
      overflow: "hidden",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      border: "none",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "6px",
      background: "#39229e",
    },
  };

  function closeModal() {
    document.body.style.overflow = "unset";
    setIsOpen(false);
  }

  Modal.setAppElement("#root");

  useEffect(
    () => IsFetchingAction({ setIsFetching, IsFetching }),
    [IsFetching]
  );

  useEffect(() => fetchData({ setData }), [IsFetching]);

  const Calculate = () => {
    data.coins.forEach((coin) => {
      var pmc = parseInt(PMCValue) * 1000000000;
      if (coin.name === document.querySelector("#coins").value)
        setResult({
          originalPrice: coin.quotes[0].price,
          after: pmc / parseInt(coin.circulatingSupply),
        });
      setIsOpen(true);
    });
  };

  return (
    <div className="price-prediction">
      <h1>Price Prediction</h1>
      <div className="form">
        <select name="coins" id="coins">
          {data.coins.map((coin, index) => (
            <option key={index} value={coin.name}>
              {coin.name}
            </option>
          ))}
        </select>
        <input
          type="number"
          placeHolder="Predictied Market cap in billion"
          value={PMCValue}
          onChange={(e) => setPMCValue(e.target.value)}
        />
        <button onClick={() => Calculate()}>Calculate</button>
        <Modal
          isOpen={IsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h1 style={{ color: "white" }}>Results:</h1>
            <ImCross
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => closeModal()}
            />
          </div>
          <h2 className="result">
            Original Price:
            <span>
              <CurrencyFormat
                value={result.originalPrice}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                prefix={"$"}
              />{" "}
            </span>
            <br />
            After:
            <span>
              <CurrencyFormat
                value={result.after}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                prefix={"$"}
              />
            </span>
          </h2>
        </Modal>
      </div>
    </div>
  );
};

export default PricePrediction;
